import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "stateSelect"]

  static values = {
    statesByCountry: Object
  }

  connect() {
    this.updateStates()
  }

  updateStates() {
    const country = this.countrySelectTarget.value
    const selectedValue = this.stateSelectTarget.dataset.selectedValue || this.stateSelectTarget.value
    const states = this.statesByCountryValue[country] || []

    this.stateSelectTarget.innerHTML = ""

    states.forEach((state) => {
      const option = document.createElement("option")
      option.value = state
      option.textContent = state
      option.selected = state === selectedValue
      this.stateSelectTarget.appendChild(option)
    })

    if (!states.includes(selectedValue)) {
      this.stateSelectTarget.value = states[0] || ""
      this.stateSelectTarget.dataset.selectedValue = this.stateSelectTarget.value
    }
  }
}
